export const getLocale = (): 'fr' | 'de' | 'en' => {
    let locale = process.env.NODE_ENV === 'test'
        ? process.env.VUE_APP_I18N_LOCALE || 'fr'
        : navigator.language.split('-')[0] || process.env.VUE_APP_I18N_LOCALE || 'fr';

    if (!locale.match('fr|en|de')) {
        locale = 'fr';
    }

    return locale;
};
